module.exports = __webpack_public_path__ + "img/4.5b436141.jpg";